export const APP_NAME = 'Row Nation'
export const PERSIST_STORE_NAME = 'row-nation-admin'
